import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { type Enum } from '@webapp/infrastructure/types/Enum'
import messages from './messages'

export const DiscoverMorePageTabs = {
  WHATS_NEW: 'whats-new',
  GUIDED_INTAKE: 'guided-intake',
  AGENTIC_AP: 'agentic-ap',
  CONTRACTS: 'contracts',
  CUSTOM_FIELDS: 'custom-fields',
} as const

export type DiscoverMorePageTab = Enum<typeof DiscoverMorePageTabs>

export interface DiscoverMorePageParams {
  tab?: DiscoverMorePageTab
}

const DiscoverMoreViewChunk = lazy(() =>
  import('@webapp/platform/discover-more/feature-sets/DiscoverMoreView').then(
    ({ DiscoverMoreView }) => ({
      default: DiscoverMoreView,
    })
  )
)

export const DiscoverMorePage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.discoverMorePageTitle)}
      breadcrumbs={[]}
    >
      <DiscoverMoreViewChunk />
    </Page>
  )
}

DiscoverMorePage.displayName = 'DiscoverMorePage'
